'use client';

import { EmblaCarouselType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { ComponentPropsWithoutRef, useEffect, useRef, useState } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import './recommended-carousel.scss';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const RecommendedCarousel = ({ children, className, ...props }: Props) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [childrenCount, setChildrenCount] = useState(0);
    const [slidesInView, setSlidesInView] = useState<number[]>([]);

    const isActive = slidesInView.length !== childrenCount;

    const [emblaRef, emblaApi] = useEmblaCarousel({
        slidesToScroll: 1,
        direction: 'ltr',
        align: 'start',
        skipSnaps: true,
        watchDrag: isActive,
        inViewThreshold: 0.9,
    });

    useEffect(() => {
        if (!emblaApi) return;
        const update = (emblaApi: EmblaCarouselType) => {
            setSlidesInView(emblaApi.slidesInView());
        };
        emblaApi.on('slidesInView', update);
        update(emblaApi);
        return () => {
            emblaApi.off('slidesInView', update);
        };
    }, [emblaApi]);

    useEffect(() => {
        const newChildrenCount = containerRef.current?.children.length;
        if (childrenCount !== newChildrenCount) {
            setChildrenCount(childrenCount);
        }
    }, [children, slidesInView]);

    return (
        <div ref={emblaRef} className={cn('recommended-carousel', className)} data-active={isActive}>
            <Layout ref={containerRef} className="recommended-carousel__container" {...props}>
                {children}
            </Layout>
        </div>
    );
};
